import React from 'react';
import Tooltip from '@mui/material/Tooltip';

const PRIORITY_COLORS = {
  high: '#e53935',
  normal: '#fb8c00',
  low: '#43a047',
  default: '#bdbdbd',
};

const PRIORITY_LABELS = {
  high: 'Высокий',
  normal: 'Средний',
  low: 'Низкий',
};

export default function PriorityStripe({ priority, fullHeight }) {
  const color = PRIORITY_COLORS[priority] || PRIORITY_COLORS.default;
  const label = PRIORITY_LABELS[priority] || priority || '—';
  return (
    <Tooltip title={label} arrow>
      <div
        style={fullHeight ? {
          display: 'block',
          height: '100%',
          minHeight: 48,
          width: '100%',
          minWidth: 6,
          borderRadius: 0,
          background: color,
          borderRight: '1px solid #e0e0e0'
        } : {
          display: 'inline-block',
          height: '32px',
          width: 6,
          borderRadius: 3,
          background: color,
          marginRight: 8,
          verticalAlign: 'middle',
        }}
      />
    </Tooltip>
  );
}
